import React from 'react'
import Button from '@amzn/meridian/button'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { ISwitchStoreButtonProps } from '../types'
import { SWITCH_STORE_BUTTON, ARIA_SWITCH_STORE_ENABLED, ARIA_SWITCH_STORE_DISABLED } from '../constants'
import './SwitchStoreButton.scss'

/**
 * SwitchStoreButton Component
 *
 * Displays a button to confirm store switching action.
 * The button is enabled only when a different store is selected.
 * Responsive design ensures button remains accessible on all screen sizes.
 */
export const SwitchStoreButton: React.FC<ISwitchStoreButtonProps> = ({ enabled, onClick }) => {
    const [bundle] = useBundle(BUNDLE_NAME)
    const ariaLabel = t(bundle, enabled ? ARIA_SWITCH_STORE_ENABLED : ARIA_SWITCH_STORE_DISABLED)

    return (
        <div className="switch-store-button-container primary-theme-button">
            <Button
                onClick={onClick}
                disabled={!enabled}
                data-atb-id="store-switch-button"
                aria-label={ariaLabel}
            >
                {t(bundle, SWITCH_STORE_BUTTON)}
            </Button>
        </div>
    )
}
